export default __webpack_public_path__ + "static/media/nft3.0bf1a9e4.png";